<template>
  <div class="app-panel">
    <div :class="['app-panel__header', headerClass]">
      <slot name="header"/>
    </div>
    <div
      v-if="$slots.default"
      class="app-panel__body"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPanel',
  props: {
    headerClass: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss">
.app-panel {
  border: 1px solid $grey-2;
  border-radius: 15px !important;
  background: #fff;

  &__header {
    padding: 17px 25px;
    font-size: 18px;
    font-weight: 700;
    background: $grey-6;
    border-radius: 15px 15px 0 0;
  }
}
</style>
